export const ReturnAndCancelType = [
    {
        id: 1,
        type: 'return',
        typeId: 2,
        reason: 'Received wrong item '
    },
    {
        id: 2,
        type: 'cancel',
        typeId: 1,
        reason: 'Ordered by mistake'
    },
    {
        id: 3,
        type: 'return',
        typeId: 2,
        reason: 'Received wrong item'
    },
    {
        id: 4,
        type: 'cancel',
        typeId: 1,
        reason: 'Shipping address issue'
    },
    {
        id: 5,
        type: 'cancel',
        typeId: 1,
        reason: 'Delay in shipping'
    },
    {
        id: 6,
        type: 'return',
        typeId: 2,
        reason: 'Found better price elsewhere'
    },
]